import DashboardLayout from '../layout/DashboardLayout.vue'
import NotFound from '../pages/NotFoundPage.vue'

import Login from 'src/pages/auth/Login.vue'
import Register from 'src/pages/auth/Register.vue'
import Dashboard from 'src/pages/Dashboard.vue'
import UserProfile from 'src/pages/UserProfile.vue'

import Clients from 'src/pages/utilisateurs/Clients.vue'
import Client_edit from 'src/pages/utilisateurs/Client_edit.vue'
import Livreurs from 'src/pages/utilisateurs/Livreurs.vue'

import Voir_livraisons from 'src/pages/rapports/Voir_livraisons.vue'
import Livreur from 'src/pages/rapports/Livreur.vue'
import Voir_livreur from 'src/pages/rapports/Voir_livreur.vue'
import Editer_livreur from 'src/pages/rapports/Editer_livreur.vue'

import Tarifs from 'src/pages/parametres/Tarifs.vue'
import Tarifs_edit from 'src/pages/parametres/Tarifs_edit.vue'
import Applications from 'src/pages/parametres/Applications.vue'

import AllUser from 'src/pages/gestionUsers/All.vue'
import CreateUser from 'src/pages/gestionUsers/create.vue'
import editRole from 'src/pages/gestionUsers/role.vue'
import AllCommerciaux from 'src/pages/gestionUsers/commerciaux.vue'
import AllLivreurs from 'src/pages/gestionUsers/Livreurs.vue'
import AllLogisticiens from 'src/pages/gestionUsers/logisticiens.vue'
import AllSuperviseurs from 'src/pages/gestionUsers/superviseurs.vue'
import AllAdministrateurs from 'src/pages/gestionUsers/administrateurs.vue'

import CreateLivraison from 'src/pages/livraison/Create.vue'
import CreateByLink from 'src/pages/livraison/CreateByLink.vue'
import LivraisonAnnulee from 'src/pages/livraison/LivraisonAnnulee.vue'
import EditLivraison from 'src/pages/livraison/Edit.vue'
import CreateLivraisonBoutique from 'src/pages/livraison/CreateForBoutique.vue'
import SavePoint from 'src/pages/livraison/SavePoint.vue'
import Realtime from 'src/pages/livraison/Realtime.vue'
import RealtimeCompleted from 'src/pages/livraison/RealtimeCompleted.vue'
import RealtimeNoCompleted from 'src/pages/livraison/RealtimeNoCompleted.vue'
import Firestore from 'src/pages/livraison/Firestore.vue'
import allRetours from 'src/pages/livraison/allRetour.vue'
import createRetour from 'src/pages/livraison/createRetour.vue'
import editRetour from 'src/pages/livraison/editRetour.vue'
import colisFutur from 'src/pages/livraison/colisFutur.vue'
import editColisFutur from 'src/pages/livraison/editColisFutur.vue'
import allColisFutur from 'src/pages/livraison/allColisFutur.vue'

import createColis from 'src/pages/livraison/createColis.vue'
import mesTests from 'src/pages/boutiques/mesTests.vue'
import editMestests from 'src/pages/boutiques/editMestests.vue'
import CreateSavePoint from 'src/pages/boutiques/createSavePoint.vue'
import Boutiques from 'src/pages/boutiques/all.vue'
import CreateBoutique from 'src/pages/boutiques/create.vue'
import EditBoutique from 'src/pages/boutiques/edit.vue'
import VoirBoutique from 'src/pages/boutiques/show.vue'

//import piececaisse from 'src/pages/pieceCaisse/pieceCaisse.vue'
import pointagehoraire from 'src/pages/pointageHoraire/acceuil.vue'

import ParLivreur from 'src/pages/rapports/ParLivreur'
import ParDate from 'src/pages/rapports/parDate'
import ParCommercial from 'src/pages/rapports/parCommercial'
import ParBoutique from 'src/pages/rapports/parBoutique'



const routes = [
  {
    path: '/',
    name: 'home',
    component: Login,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  

  {
    path: '/admin',
    meta: {
      authRequired: true,
    },
    component: DashboardLayout,
    redirect: '/admin/dashboard',
    children: [

      /*Page statique simple*/
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard
      },


      // Gestion des utilisateurs - create user - edit user - commerciaux - livreurs - recourvreurs - superviseurs - admin
      {
        path : 'gestion/utilisateurs',
        name : 'utilisateurs',
        component: AllUser
      },
      {
        path : 'gestion/utilisateur/create',
        name : 'createUser',
        component: CreateUser
      },
      {
        path : 'gestion/utilisateur/role/edit',
        name : 'editRole',
        component: editRole
      },
      {
        path : 'gestion/commerciaux',
        name : 'commerciaux',
        component: AllCommerciaux
      },
      {
        path : 'gestion/livreurs',
        name : 'livreurs',
        component: AllLivreurs
      },
      {
        path : 'gestion/logisticiens',
        name : 'logisticiens',
        component: AllLogisticiens
      },
      {
        path : 'gestion/superviseurs',
        name : 'superviseurs',
        component: AllSuperviseurs
      },
      {
        path : 'gestion/administrateurs',
        name : 'administrateurs',
        component: AllAdministrateurs
      },
      
    
      // Livraison create - create boutique - en cours - retour - create retour - terminée
      {
        path : 'livraison/create',
        name : 'CreateLivraison',
        component: CreateLivraison
      },
      {
        path : 'livraison/createColis',
        name : 'createColis',
        component: createColis
      },
      {
        path : '/EditLivraison/:id',
        name : 'EditLivraison',
        component: EditLivraison
      },
      {
        path : 'livraison/create/boutique',
        name : 'CreateLivraisonBoutique',
        component: CreateLivraisonBoutique
      },
      {
        path : 'livraison/savepoint',
        name : 'livraison/savepoint',
        component: SavePoint
      },
      {
        path : 'livraison/encours',
        name : 'livraison/realtime',
        component: Realtime
      },
      {
        path : 'livraison/completed',
        name : 'livraison/completed',
        component: RealtimeCompleted
      },
      {
        path : 'livraison/nocompleted',
        name : 'livraison/nocompleted',
        component: RealtimeNoCompleted
      },
      {
        path : 'livraison/firestore',
        name : 'firestore',
        component: Firestore
      },
      {
        path: 'livraison/retours',
        name: 'allRetours',
        component :allRetours,
      },
      {
        path: 'livraison/retour/create',
        name: 'createretour',
        component: createRetour
      },
      {
        path: 'livraison/retour/edit/:id',
        name: 'editretour',
        component: editRetour
      },
      {
        path: 'livraison/livraisonannulee',
        name: 'livraisonannulee',
        component: LivraisonAnnulee
      },
      {
        path: 'livraison/colisfutur',
        name: 'colisfutur',
        component: colisFutur
      },
      {
        path: '/editcolisfutur/:id',
        name: 'editcolisfutur',
        component: editColisFutur
      },
      {
        path: 'livraison/allcolisfutur',
        name: 'allcolisfutur',
        component: allColisFutur
      },

      // Boutiques - create boutique - edit boutique - voir boutique
      {
        path : 'boutiques',
        name : 'boutiques',
        component: Boutiques
      },
      {
        path : 'boutique/create',
        name : 'CreateBoutique',
        component: CreateBoutique
      },
      {
        path : 'boutiques/mestests',
        name : 'mesTests',
        component: mesTests
      },
      {
        path : 'boutiques/editmestests/:id',
        name : 'editMestests',
        component: editMestests
      },
      {
        path : '/createSavePoint/:id',
        name : 'CreateSavePoint',
        component: CreateSavePoint
      },
      {
        path : '/EditBoutique/:id',
        name : 'EditBoutique',
        component: EditBoutique
      },
      {
        path : 'livraison/boutique',
        name : 'VoirBoutique',
        component: VoirBoutique
      },
      


      // Voir les: Clients - Livreurs - edit livreur - voir livreur, Modifier les clients: edit client
      {
        path: 'user',
        name: 'user',
        component: UserProfile
      },
      {
        path: 'clients',
        name: 'Clients',
        component: Clients
      },
      {
        path: '/client_edit/:id',
        name: 'Client_edit',
        component: Client_edit
      },

      {
        path: 'livreurs',
        name: 'Livreurs',
        component: Livreurs
      },
      {
        path: '/editer_livreur/:id',
        name: 'Editer_livreur',
        component: Editer_livreur
      },
      {
        path: '/voir_livreur/:id',
        name: 'Voir_livreur',
        component: Voir_livreur
      },
     

      // Les rapports
      {
        path : 'rapport/livreurs',
        name : 'RapportParLiveur',
        component: ParLivreur
      },
      {
        path : 'rapport/date',
        name : 'RapportParDate',
        component: ParDate
      },
      {
        path : 'rapport/commerciaux',
        name : 'RapportParCommercial',
        component: ParCommercial
      },
      {
        path : 'rapport/boutiques',
        name : 'RapportParBoutique',
        component: ParBoutique
      },
      {
        path: '/voir_livraisons/:id',
        name: 'Voir_livraisons',
        component: Voir_livraisons
      },

      {
        path: 'livreur',
        name: 'Livreur',
        component: Livreur
      },
     

      // Tarifs - Edit tarif - 
      {
        path: 'tarifs',
        name: 'Tarifs',
        component: Tarifs
      },
      {
        path: 'tarifs_edit',
        name: 'Tarifs_edit',
        component: Tarifs_edit
      },


      // Applications
      {
        path: 'applications',
        name: 'Applications',
        component: Applications
      },


      //{
        //path: 'pieceCaisse/accueil',
        //name: 'piececaisse',
        //component: piececaisse
      //},

      // Pointage Horaire
      {
        path: 'pointageHoraire/acceuil',
        name: 'pointagehoraire',
        component: pointagehoraire
      },
      
    ]
  },

  {
    path: '/createbylink',
    name : 'createbylink',
    component: CreateByLink
  },

  { path: '*', component: NotFound }
]

export default routes
